<po-page-list
  p-title="Validação de Cadastro - {{tipoCadastro}}"
  [p-breadcrumb]="breadcrumb">
  <po-container class="po-md-12">
    <po-input class="po-md-2 po-mt-1"
      name="codigo"
      p-label="Código"
      [(ngModel)]="filtroPrincipal.CCODIGO"
      p-maxlength="6">
    </po-input>
    <po-input class="po-md-2 po-mt-1"
      name="loja"
      p-label="Loja"
      [(ngModel)]="filtroPrincipal.CLOJA"
      p-maxlength="2">
    </po-input>
    <po-input class="po-md-2 po-mt-1"
      name="nomefantasia"
      p-label="Nome Fantasia"
      [(ngModel)]="filtroPrincipal.CNOMEREDUZ"
      p-maxlength="20">
    </po-input>
    <po-input class="po-md-2 po-mt-1"
      name="cgc"
      p-label="CNPJ/CPF"
      [(ngModel)]="filtroPrincipal.CCGC"
      p-maxlength="14">
    </po-input>
    <po-select class="po-md-2 po-mt-1"
      name="CCADASTRO"
      p-label="Cadastro"
      [(ngModel)]="filtroPrincipal.CCADASTRO"
      [p-options]="[{value: '1', label: 'Cliente'},{value: '2', label: 'Fornecedor'}]"
      (p-change)="validaCadastro()">
    </po-select>
    <po-button class="po-md-1 po-mt-4"
      p-label="Filtrar"
      p-kind="primary"
      (p-click)="buscaRegistros()">
    </po-button>
  </po-container>
  <po-table class="po-md-12 po-mt-2"
    p-container="shadow"
    [p-height]="550"
    [p-columns]="poTableColumnsPrincipal"
    [p-items]="tabelaPrincipalItems"
    [p-actions]="poTableActionsPrincipal"
    p-hide-columns-manager="true"
    p-actions-right="true"
    p-striped="true">
  </po-table>
</po-page-list>

<po-modal #modalVisualizarHistorico p-title="Histórico" p-hide-close="true">
  <div class="po-md-12">
    <po-info class="po-md-3"  p-label="Chave"             p-value="{{historicoChave}}"   p-orientation="horizontal"></po-info>
    <po-info class="po-md-3"  p-label="{{tipoCadastro}}"  p-value="{{historicoCliFor}}"  p-orientation="horizontal"></po-info>
    <po-info class="po-md-2"  p-label="Alias"             p-value="{{historicoAlias}}"   p-orientation="horizontal"></po-info>
  </div>
  <div class="po-md-12">
    <po-table class="po-md-12 po-mt-2"
      p-container="shadow"
      [p-height]="220"
      [p-columns]="poTableColumnsHistorico"
      [p-items]="tabelaHistoricoItems"
      p-hide-columns-manager="true"
      p-actions-right="true"
      p-selectable="true"
      p-single-select="true"
      (p-selected)="registroHistoricoSelecionado($event)"
      p-striped="true">
    </po-table>
  </div>
  <div class="po-md-12">
    <po-textarea class="po-md-12"
      [(ngModel)]="textAreaHistorico"
      p-rows="5"
      p-readonly="true">
    </po-textarea>
  </div>
</po-modal>

<po-modal #modalDesbloquearCadastro p-title="Desbloquear Cadastro" p-hide-close="true">
  <div class="po-md-12">
    <po-info class="po-md-12"  p-label="{{tipoCadastro}}"  p-value="{{informacoesCliFor}}" p-orientation="horizontal"></po-info>
  </div>
  <div class="po-md-12">
    <po-textarea class="po-md-12"
      p-placeholder="Digite uma justificativa para realizar o desbloqueio."
      [(ngModel)]="justificativaDesbloqueio"
      p-rows="5">
    </po-textarea>
  </div>
  <po-modal-footer>
    <po-button class="po-md-2"
      p-label="Fechar"
      p-danger="true"
      (p-click)="limpaInformacoes() ; modalDesbloquearCadastro.close()">
    </po-button>
    <po-button class="po-md-2"
      p-label="Confirmar"
      p-kind="primary"
      (p-click)="confirmarDesbloqueio()"
      [p-disabled]="formDesbloqueioValid()">
    </po-button>
  </po-modal-footer>
</po-modal>

<po-modal #modalBloquearCadastro p-title="Bloquear Cadastro" p-hide-close="true">
  <div class="po-md-12">
    <po-info class="po-md-12"  p-label="{{tipoCadastro}}"  p-value="{{informacoesCliFor}}" p-orientation="horizontal"></po-info>
  </div>
  <div class="po-md-12">
    <po-textarea class="po-md-12"
      p-placeholder="Digite uma justificativa para realizar o Bloqueio."
      [(ngModel)]="justificativaBloqueio"
      p-rows="5">
    </po-textarea>
  </div>
  <po-modal-footer>
    <po-button class="po-md-2"
      p-label="Fechar"
      p-danger="true"
      (p-click)="limpaInformacoes() ; modalBloquearCadastro.close()">
    </po-button>
    <po-button class="po-md-2"
      p-label="Confirmar"
      p-kind="primary"
      (p-click)="confirmarBloqueio()"
      [p-disabled]="formBloqueioValid()">
    </po-button>
  </po-modal-footer>
</po-modal>
